import React from 'react'
import { VisuallyHidden } from '../../common/VisuallyHidden'

const hiddenStyles = {
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  border: 0,
  width: '1px',
  height: '1px',
  overflow: 'hidden',
  position: 'absolute',
  whiteSpace: 'nowrap',
  caretColor: 'transparent',
  userSelect: 'none',
} as const

type VisuallyHiddenInputProps = {
  name: string
}

export const VisuallyHiddenInput = ({ name }: VisuallyHiddenInputProps) => {
  return (
    <VisuallyHidden>
      <input name={name} aria-hidden="true" tabIndex={-1} readOnly style={hiddenStyles} />
    </VisuallyHidden>
  )
}
